// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from '../../i18n/I18n'

import classNames from 'classnames';

import ArrayUtils from '../../utils/ArrayUtils'

import TextareaInput from './TextareaInput';

export default class TextInputLocalized extends Component {

  state = {
    currentLocale: _.find(this.props.locales, locale =>
      locale.locale.indexOf(I18n.getCurrentLanguageWithoutRegionCode()) > -1
    ),
  }

  static defaultProps = {
    isRequired: false,

    type: 'text',

    readOnly: false,

    onChange: () => { console.error('TextInputLocalized onChange not specified'); },

    onBlur: () => {},

    max: 0,

    error: false,

    multiLine: false,

    values: []
  };

  static propTypes = {
    locales: PropTypes.array,

    values: PropTypes.array,

    onChange: PropTypes.func,

    onBlur: PropTypes.func,

    className: PropTypes.string,

    isRequired: PropTypes.bool,

    type: PropTypes.string,

    readOnly: PropTypes.bool,

    max: PropTypes.number,

    onMaxReached: PropTypes.func,

    error: PropTypes.bool,

    multiLine: PropTypes.bool,
  };

  onChange = (event: Event) => {
    const value = event.target.value;
    const { type, max, onMaxReached } = this.props;

    if (type !== "number" && max !== 0 && value.length > max) {
      if (_.isFunction(onMaxReached)) {
        onMaxReached();
      }
    } else {
      let values = this.props.values || []

      if (_.find(values, { locale: this.state.currentLocale.locale })) {
        if (!_.isEmpty(value)) {
          values = ArrayUtils.updateObject(
            values,
            {
              locale: this.state.currentLocale.locale,
              text: value,
            },
            oldValue => oldValue && oldValue.locale === this.state.currentLocale.locale
          )
        } else {
          values = ArrayUtils.removeObject(
            values,
            oldValue => oldValue.locale === this.state.currentLocale.locale
          )
        }
      } else {
        values = [
          ...values,
          {
            locale: this.state.currentLocale.locale,
            text: value,
          }
        ]
      }

      this.props.onChange(values);
    }
  }

  handleChangeLocale = (locale) => {
    this.setState({
      currentLocale: locale
    }, this.input.focus())
  }

  render() {
    const { locales, isRequired, values, max, type, multiLine } = this.props;

    const classNameWrapper = classNames('text_input text_input_localized', {
      multiLine
    });

    const className = classNames('form-control', this.props.className, {
      'read-only': this.props.readOnly,
      'error': this.props.error,
    });

    const localizedValue = _.find(values, { locale: this.state.currentLocale.locale})

    return (
      <span className={classNameWrapper}>
        <div className="input-group">
          <div className="input-group-btn">
            <button
              type="button"
              className="btn btn-default dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {this.state.currentLocale.name} <span className="caret"></span>
            </button>
            <ul className="dropdown-menu">
              {locales.map(locale => (
                <li>
                  <a onClick={() => this.handleChangeLocale(locale)}>{locale.name}</a>
                </li>
              ))}
            </ul>
          </div>
          {!multiLine ?
            <input
              ref={input => this.input = input}
              {...this.props}
              type={type}
              onChange={this.onChange}
              onBlur={this.props.onBlur}
              value={localizedValue ? localizedValue.text : ''}
              className={className}
              required={isRequired === true ? "required" : ""}
              readOnly={this.props.readOnly}
            />
          :
            <textarea
              ref={input => this.input = input}
              {...this.props}
              type={type}
              onChange={this.onChange}
              onBlur={this.props.onBlur}
              value={localizedValue ? localizedValue.text : ''}
              className={className}
              required={isRequired === true ? "required" : ""}
              readOnly={this.props.readOnly}
            />
          }
        </div>
        {type !== "number" && max !== 0 &&
          <div
            className="text_input__counter"
          >
            {localizedValue ? localizedValue.text.length : 0} / {max}
          </div>
        }
      </span>
    );
  }

}
